export default "__VITE_ASSET__cfeC$1VK__"